/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.support.portal.rpc.TicketsRpc
 */
import * as References from './TicketsRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.support.portal.rpc.TicketsRpc#searchTickets
 */
export const SEARCH_TICKETS_QUERY_FIELD_NAME = 'com_hubspot_support_portal_rpc_TicketsRpc_searchTickets';
export const SEARCH_TICKETS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_TICKETS_QUERY_FIELD_NAME,
  args: ['params', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.searchTicketsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.support.portal.rpc.TicketsRpc#searchTicketsForNavigation
 */
export const SEARCH_TICKETS_FOR_NAVIGATION_QUERY_FIELD_NAME = 'com_hubspot_support_portal_rpc_TicketsRpc_searchTicketsForNavigation';
export const SEARCH_TICKETS_FOR_NAVIGATION_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_TICKETS_FOR_NAVIGATION_QUERY_FIELD_NAME,
  args: ['params', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.searchTicketsForNavigationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.support.portal.rpc.TicketsRpc#getTicketDetails
 */
export const GET_TICKET_DETAILS_QUERY_FIELD_NAME = 'com_hubspot_support_portal_rpc_TicketsRpc_getTicketDetails';
export const GET_TICKET_DETAILS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_TICKET_DETAILS_QUERY_FIELD_NAME,
  args: ['params', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getTicketDetailsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.support.portal.rpc.TicketsRpc#closeTicket
 */
export const CLOSE_TICKET_MUTATION_FIELD_NAME = 'com_hubspot_support_portal_rpc_TicketsRpc_closeTicket';
export const CLOSE_TICKET_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CLOSE_TICKET_MUTATION_FIELD_NAME,
  args: ['params', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.closeTicketRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});